export default __webpack_public_path__ + "static/media/BlueBurger.53484952.svg";